import { onBeforeUnmount, onMounted, watch, type Ref } from 'vue'
import { escapeRegExp, findTextRanges } from '@/lib/textRange'

// Un seul Highlight partagé par toutes les cards et le viewer : chaque instance y ajoute/retire ses ranges.
const searchHighlight =
  typeof Highlight === 'undefined' ? null : new Highlight()
if (searchHighlight) CSS.highlights.set('search', searchHighlight)

export function useSearchHighlight(
  roots: () => (HTMLElement | null | undefined)[],
  terms: Ref<string[]>,
  // Le texte rendu change sans que les termes changent (card recyclée, nouveau doc).
  content: () => unknown
) {
  let ranges: Range[] = []

  function clear() {
    ranges.forEach(range => searchHighlight?.delete(range))
    ranges = []
  }

  function apply() {
    clear()
    if (!searchHighlight) return
    const words = terms.value.filter(Boolean)
    if (words.length === 0) return
    // Début de mot imposé (« RN » ne s'allume pas dans « gouvernement ») ; fin libre pour les pluriels/flexions.
    const pattern = new RegExp(
      `(?<![\\p{L}\\p{N}])(?:${words.map(escapeRegExp).join('|')})`,
      'giu'
    )
    ranges = roots().flatMap(root =>
      root ? findTextRanges(root, pattern) : []
    )
    ranges.forEach(range => searchHighlight.add(range))
  }

  onMounted(apply)
  watch([terms, content], apply, { flush: 'post' })
  onBeforeUnmount(clear)
}
